import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { OrderProduct } from "../OrderProduct.js";

export interface OrderProductPriceSettings {
	applyTax: boolean;
}

export function getPriceOfOrderProduct(
	{ info, quantity }: Pick<OrderProduct, "info" | "quantity">,
	{ applyTax }: OrderProductPriceSettings,
): {
	taxRate: number;
	unitWithoutTax: number;
	unitWithTax: number;
	withoutTax: number;
	withTax: number;
} {
	const taxRate = applyTax ? info.price.taxRate : 0;
	const unitWithoutTax = info.price.withoutTax;
	const unitWithTax = applyTax ? info.price.withTax : unitWithoutTax;
	const totalWithoutTax = roundToPlaces(unitWithoutTax * quantity, 2);
	const totalWithTax = roundToPlaces(totalWithoutTax + roundToPlaces(totalWithoutTax * (taxRate / 100), 2), 2);

	return {
		taxRate,
		unitWithoutTax,
		unitWithTax,
		withoutTax: totalWithoutTax,
		withTax: totalWithTax,
	};
}
